exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".static-content h3{margin-top:40px;margin-bottom:25px}@media(max-width: 767px){.static-content h3{margin-top:35px;margin-bottom:10px}}.static-content strong{font-family:\"TTCommons-DemiBold\",sans-serif}", ""]);

// exports
